export const TERMINAL_END_NAME = "end";
